import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';

import { DartsScoreboardBaseComponent } from './scoreboard-base/darts-scoreboard-base.component';

@Component({
    selector: 'ms-darts-scoreboard',
    templateUrl: './darts-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ValueSliderDirective, AsyncPipe],
})
export class DartsScoreboardComponent extends DartsScoreboardBaseComponent {
    @HostBinding('class') className = 'set-game';
    @Input() hideScoreBoardColumnFooter = false;
}
